module.exports = __webpack_public_path__ + "img/NGC-6853.b4514100.jpg";